module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.22.0@babel-runtime/core-js/object/assign.js
 ** module id = 670
 ** module chunks = 0
 **/